module.exports = __webpack_public_path__ + "img/guide.f54dd238.jpg";